function UserProfileItem({ src, title, label }) {

    return (
        <>
            <div className="el-flex-area  mb-3 mb-lg-0">
                <div className="location-icon">
                    {src && (<img src={src} alt=" " className="me-3 " />)}
                    
                </div>
                <div className="el-content-detail">
                    {title != "Username" && (<p className="el-request-detail-profile-title">
                        {title}
                    </p>)}
                    {title == "Username" ? (<h3>{label}</h3>) : <h4 className={`el-request-detail-profile-name ${label == 'Active' ? 'active' : ''} `}>{label}</h4>}
                </div>
            </div>
        </>
    );
}

export default UserProfileItem